<template>
  <div class="invoiceApplicationList">
    <vm-table
        ref="vmTable"
        height="60vh"
        :filter.sync="filter"
        module="basic"
        url="clearAccount/clearAccount/pageList">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.clearingManagementEdit.open(0)">新建</el-button>
      </div>
      <template slot="adSearch">
        <vm-search label="清账日期">
          <div class="block">
            <el-date-picker
                v-model="filter.clearAccountDateBegin"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                style="width: 190px"
                placeholder="选择开始日期"/>
          </div>
        </vm-search>
        <vm-search label="至">
          <div class="block">
            <el-date-picker
                v-model="filter.clearAccountDateEnd"
                value-format="yyyy-MM-dd 23:59:59"
                type="datetime"
                style="width: 190px"
                placeholder="选择结束日期"/>
          </div>
        </vm-search>
        <vm-search label="编号">
          <el-input v-model.trim="filter.no" clearable/>
        </vm-search>
        <vm-search label="客户">
          <el-input v-model.trim="filter.customerName" clearable/>
        </vm-search>
        <vm-search label="创建日期">
          <div class="block">
            <el-date-picker
                v-model="filter.createTimeBegin"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                style="width: 190px"
                placeholder="选择开始日期"/>
          </div>
        </vm-search>
        <vm-search label="至">
          <div class="block">
            <el-date-picker
                v-model="filter.createTimeEnd"
                value-format="yyyy-MM-dd 23:59:59"
                type="datetime"
                style="width: 190px"
                placeholder="选择结束日期"/>
          </div>
        </vm-search>
      </template>
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-table
              :data="getTableDataDetail(scope.row)"
              style="width: 90%;margin: 0 auto">
            <el-table-column label="开票凭证" prop="invoiceNo"/>
            <el-table-column label="凭证号" prop="fiNo"/>
            <el-table-column label="凭证类型" prop="fiType">
              <template v-slot="scope">
                <span v-if="scope.row.fiType === 10">收款单</span>
                <span v-if="scope.row.fiType === 20">开票单</span>
              </template>
            </el-table-column>
            <el-table-column label="发货单" prop="deliveryBillNo"/>
            <el-table-column label="行号" prop="rowIndex"/>
            <el-table-column label="销售订单" prop="salesOrderNo"/>
            <el-table-column label="金额" prop="amount"/>
            <el-table-column align="center" prop="status" label="状态">
              <template v-slot="scope">
                <span v-if="scope.row.status === 0">待清账</span>
                <span v-else-if="scope.row.status === 10">清账中</span>
                <span v-else-if="scope.row.status === 20">已冲销</span>
                <span v-else-if="scope.row.status === 30">已清账</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="no" label="编号"/>
      <el-table-column align="center" prop="clearAccountDate" label="清账日期">
        <template slot-scope="scope">
          <span>{{scope.row.clearAccountDate.slice(0,10)}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="customerName" label="客户"/>
      <el-table-column align="center" prop="createTime" label="创建时间"/>
      <el-table-column align="center" prop="amount" label="金额"/>
      <el-table-column align="center" prop="status" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0">待处理</span>
          <span v-else-if="scope.row.status === 10">处理中</span>
          <span v-else-if="scope.row.status === 20">已处理</span>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="180px">
        <template slot-scope="scope">
          <el-button
              v-if="scope.row.status === 0 || scope.row.status === 10"
              :loading="submitLoading"
              type="primary"
              plain
              @click="submit(scope.row.pkid)">
            提交
          </el-button>
          <el-button v-if="scope.row.status === 0" type="primary" @click="$refs.clearingManagementEdit.open(scope.row.pkid)">编辑</el-button>
          <el-button v-if="scope.row.status === 0" type="danger" @click="deleteRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <clearing-management-edit ref="clearingManagementEdit" @save-success="getList"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import ClearingManagementEdit from "@/views/invoicingManagement/clearingManagement/ClearingManagementEdit";

  export default {
    name: "InvoiceApplicationList",
    components: { VmTable, VmSearch, ClearingManagementEdit},
    data() {
      return {
        submitLoading: false,
        idList: "",
        filter: {
          no: "",
          customerName: "",
          clearAccountDateBegin: "",
          clearAccountDateEnd: "",
          createTimeBegin: "",
          createTimeEnd: "",
        },
        tableDataDetail:[],
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      getTableDataDetail(row) {
        console.log(row);
        if (row.details === null) {
          this.$http
            .get("basic", `clearAccount/clearAccountDetail/${row.pkid}`)
            .then(resp => {
              console.log(resp);
              row.details = resp.details;
            });
        }
        return row.details;
      },
      submit(id) {
        console.log(id);
        this.submitLoading = true;
        this.$http
          .get("basic",`clearAccount/submit/${id}`)
          .then(() => {
            this.$message.success("提交成功");
            this.getList(1);
            this.submitLoading = false;
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },
      deleteRow(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic","clearAccount", row.pkid).then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
          });
        });
      },
    },
  };
</script>
<style lang="scss">
</style>
